import apiCall from 'utils/axios';

import { notifyWithSnack } from './notifications';
import { API_URL } from 'config';

// actions
export const GET_USER_INFO_LOADING = 'mus/GET_USER_INFO/LOADING';
export const GET_USER_INFO_LOADED = 'mus/GET_USER_INFO/LOADED';
export const GET_USER_INFO_FAILED = 'mus/GET_USER_INFO/FAILED';

export const CREATE_CLASS_LOADED = 'mus/CREATE_CLASS/LOADED';

export const REMOVE_CLASS_LOADED = 'mus/REMOVE_CLASS/LOADED';

export const REMOVE_STUDENT_LOADED = 'mus/REMOVE_STUDENT/LOADED';

export const GET_STUDENT_INFO_LOADING = 'mus/GET_STUDENT_INFO/LOADING';
export const GET_STUDENT_INFO_LOADED = 'mus/GET_STUDENT_INFO/LOADED';
export const GET_STUDENT_INFO_FAILED = 'mus/GET_STUDENT_INFO/FAILED';
export const CLEAR_STUDENT_INFO = 'mus/CLEAR_STUDENT_INFO';

export const UPDATE_STUDENT_LOADED = 'mus/UPDATE_STUDENT/LOADED';
export const UPDATE_USER_PROFILE_LOADING = 'mus/UPDATE_USER_PROFILE/LOADING';
export const UPDATE_USER_PROFILE_SUCCESS = 'mus/UPDATE_USER_PROFILE/SUCCESS';
export const UPDATE_USER_PROFILE_FAILED = 'mus/UPDATE_USER_PROFILE/FAILED';
export const UPDATE_USER_PROFILE_LOADED = 'UPDATE_USER_PROFILE_LOADED';

// creators
export const getUserInfoLoading = () => ({ type: GET_USER_INFO_LOADING });
export const getUserInfoLoaded = (payload) => ({ type: GET_USER_INFO_LOADED, payload });
export const getUserInfoFailed = () => ({ type: GET_USER_INFO_FAILED });

export const createClassLoaded = (payload) => ({ type: CREATE_CLASS_LOADED, payload });

export const removeClassLoaded = (payload) => ({ type: REMOVE_CLASS_LOADED, payload });

export const createStudentsLoaded = (payload) => ({ type: CREATE_CLASS_LOADED, payload });

export const removeStudentLoaded = (payload) => ({ type: REMOVE_STUDENT_LOADED, payload });

export const getStudentInfoLoading = () => ({ type: GET_STUDENT_INFO_LOADING });
export const getStudentInfoLoaded = (payload) => ({ type: GET_STUDENT_INFO_LOADED, payload });
export const getStudentInfoFailed = () => ({ type: GET_STUDENT_INFO_FAILED });
export const clearStudentInfo = () => ({ type: CLEAR_STUDENT_INFO });

export const updateStudentLoaded = (payload) => ({ type: UPDATE_STUDENT_LOADED, payload });

export const updateUserProfileLoading = () => ({ type: UPDATE_USER_PROFILE_LOADING });
export const updateUserProfileSuccess = (payload) => ({
  type: UPDATE_USER_PROFILE_SUCCESS,
  payload,
});

export const updateUserProfileFailed = () => ({ type: UPDATE_USER_PROFILE_FAILED });


export const updateUserProfileUserState = (payload) => {
  return {
      type: UPDATE_USER_PROFILE_LOADED,
      user: payload
  };
}

// side effects
export const getUser = () => (dispatch) => {
  dispatch(getUserInfoLoading());
  return apiCall({ url: '/classrooms' })
    .then(({ data = {} }) => {
      dispatch(getUserInfoLoaded(data['users/educator']));
    })
    .catch((err) => {
      dispatch(getUserInfoFailed());
      return Promise.reject(err.toJSON());
    });
};

export const createClassroom = (name, onSuccess) => (dispatch) =>
  apiCall({ url: '/classrooms', method: 'POST', data: { classroom: { name } } })
    .then(({ data: { classroom } }) => {
      onSuccess?.(classroom);
      dispatch(createClassLoaded(classroom));
      return Promise.resolve(classroom);
    })
    .catch((err) => {
      dispatch(notifyWithSnack({ message: err.message, type: 'error' }));
    });

export const removeClassroom = (classId, onSuccess) => (dispatch) =>
  apiCall({ url: `/classrooms/${classId}`, method: 'DELETE' }).then(() => {
    dispatch(removeClassLoaded(classId));
    onSuccess?.();
  });

export const removeStudent = (studentId, classId) => (dispatch) =>
  apiCall({ url: `/students/${studentId}`, method: 'DELETE' })
    .then(() => dispatch(removeStudentLoaded({ studentId, classId })))
    .catch((err) => console.log(err));

export const getStudent = (studentId) => (dispatch) => {
  dispatch(getStudentInfoLoading());
  return apiCall({ url: `/students/${studentId}` })
    .then(({ data = {} }) => dispatch(getStudentInfoLoaded(data['users/student'])))
    .catch((err) => dispatch(getStudentInfoFailed()));
};

export const updateStudent = (studentId, classId, payload) => (dispatch) =>
  apiCall({ url: `/students/${studentId}`, method: 'PATCH', data: { ...payload } })
    .then(({ data }) => dispatch(updateStudentLoaded({ data: data['users/student'], classId })))
    .catch((err) => {
      const errorMessage = err.response?.data?.errors || 'An error occurred while updating the student.';
      return Promise.reject(errorMessage);
    });

export const resetAllPasswords = (classId, className, data) => (dispatch) =>
  apiCall({ url: `/classrooms/${classId}/reset_passwords`, method: 'PATCH', data })
    .then(() => dispatch(notifyWithSnack({ message: `All passwords for ${className} have been reset.` })))
    .catch(() => dispatch(notifyWithSnack({ message: `Couldn't reset passwords.`, type: 'error' })));

export const updateUserProfile = (user_key, params) => (dispatch) => {
  dispatch(updateUserProfileLoading());  // Dispatch loading action
  const payload = {
    user_key,
    user: params,
  };
  return apiCall({
    url: `/profile_update`,
    baseURL: API_URL + '/api/v1/users', // Custom baseURL
    method: 'PATCH',
    data: payload,
  })
    .then((response) => {
      dispatch(updateUserProfileSuccess(response.data));  // Dispatch success action
      dispatch(updateUserProfileUserState(params));  // Dispatch success action
      return response.data;
    })
    .catch((err) => {
      dispatch(updateUserProfileFailed());  // Dispatch failure action
      const errorMessage = err.response?.data?.errors || 'An error occurred while updating the data.';
      return Promise.reject(errorMessage);
    });
};

export const confirmEmail = (user_key, params) => (dispatch) => {
  const payload = {
    user_key,
    ...params,
  };
  return apiCall({
    url: `/confirm_email`,
    baseURL: API_URL + '/api/v1/users', // Custom baseURL
    method: 'POST',
    data: payload,
  })
    .then((response) => {
      if (params.email_confirmation == 3) {
        window.location.href = '/';
        return;
      }
      dispatch(updateUserProfileSuccess(response.data));  // Dispatch success action
      return response.data;
    })
    .catch((err) => {
      const errorMessage = err.response?.data?.errors || 'An error occurred while confirming the email.';
      return Promise.reject(errorMessage);
    });
}
